// action - state management
export const LOGIN = 'auth/login';
export const LOGOUT = 'auth/logout';

// ==============================|| ACCOUNT REDUCER ||============================== //

const authReducer = (state, action) => {
    switch (action.type) {
        case LOGIN: {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default authReducer;
